import * as React from "react";
import type { SVGProps } from "react";

const BlinkLogoOneLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
   /*  width={469}
    height={175} */
    viewBox="0 0 469 175"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_7120_39041)">
      <path
        d="M467.792 158.26L416.182 108.26C422.462 101.84 457.572 68.6601 462.662 62.7701C467.172 55.3901 454.832 43.8601 448.012 49.7001C448.002 49.7001 447.992 49.7001 447.972 49.7001L391.992 103.81V7.82012C391.872 -2.62988 370.992 -2.58988 370.992 7.80012V165.38C371.562 175.49 391.422 175.64 391.982 165.46C391.982 165.46 391.982 165.46 391.992 165.46V112.46C391.992 112.46 453.052 173.77 453.322 173.85C461.222 179.29 474.112 165.76 467.782 158.31C467.782 158.29 467.782 158.28 467.782 158.26H467.792Z"
        fill="#2EE69F"
      />
      <path
        d="M158.88 8.89986C158.88 -1.27014 138 -1.23014 138 8.74986C138 8.74986 138 163.33 138 165.61C138 175.76 158.89 176.1 158.89 165.94V8.88986L158.88 8.89986Z"
        fill="#2EE69F"
      />
      <path
        d="M210.88 82.8999C210.88 72.7299 190 72.7699 190 82.7499C190 82.7499 190 163.33 190 165.61C190 175.76 210.89 176.1 210.89 165.94V82.8899L210.88 82.8999Z"
        fill="#2EE69F"
      />
      <path
        d="M88.24 87.3797C96.59 83.9097 102.55 78.9997 106.12 72.6497C109.69 66.3097 111.47 59.3997 111.47 51.9297C111.47 37.3297 105.99 26.5597 95.02 19.6097C84.06 12.6597 68.74 9.17969 49.07 9.17969C41.24 9.17969 34.01 9.47969 27.4 10.0897C20.78 10.6997 14.52 11.8697 8.6 13.6097C2.87 15.1797 0 18.4797 0 23.5197V156.99C0 162.9 3.66 166.9 10.97 168.98C17.24 170.72 23.8 171.89 30.68 172.5C37.55 173.11 44.65 173.41 51.96 173.41C73.02 173.41 89.25 169.59 100.65 161.94C112.05 154.3 117.75 142.56 117.75 126.75C117.75 117.89 115.31 109.94 110.44 102.9C105.57 95.8597 98.17 90.6897 88.25 87.3897L88.24 87.3797ZM21 28.8897C24.83 28.1997 28.96 27.6297 33.4 27.1897C37.84 26.7597 43.1 26.5397 49.19 26.5397C76.34 26.5397 89.92 35.1397 89.92 52.3497C89.92 60.6897 87.09 67.2997 81.44 72.1597C75.78 77.0297 67.47 79.4597 56.51 79.4597H21V28.8897ZM84.96 148.46C77.47 153.24 66.51 155.63 52.06 155.63C46.49 155.63 40.96 155.37 35.48 154.85C30 154.33 25.17 153.64 20.99 152.76V96.4497H56.5C69.55 96.4497 79.43 99.0997 86.13 104.4C92.83 109.7 96.18 116.87 96.18 125.91C96.18 136.17 92.44 143.68 84.95 148.46H84.96Z"
        fill="#2EE69F"
      />
      <path
        d="M331.35 59.17C317.65 47.32 287.18 46.09 268.82 51.9C261.37 54.15 255.39 56.66 250.88 59.43C244.01 63.82 241.09 67.32 241 75.27V165.69C241.11 167.82 242.07 169.44 243.93 170.89C249.3 175.19 261.66 173.29 262.26 165.4C262.26 165.41 262.26 75.67 262.26 75.67C281.7 63.01 325.1 60.88 324.2 93.7C324.2 93.7 324.2 165.42 324.2 165.44C324.11 167.76 325.35 169.39 327.13 170.9C332.26 174.99 344.49 173.63 344.98 165.8C344.98 165.8 345 165.8 345 165.79V92.66C345 77.43 340.45 66.27 331.35 59.17Z"
        fill="#2EE69F"
      />
    </g>
    <defs>
      <clipPath id="clip0_7120_39041">
        <rect width="469" height="175" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BlinkLogoOneLine;
